import i18n from 'i18n';

type FormFieldConfig = {
	variable: string;
	title: string;
	excludeFromMetadata: boolean;
	required: boolean;
	pageId?: string;
	options?: {
		id: string;
		label: string;
		value: string;
		isChecked: boolean;
	}[];
};

type FormField = {
	id: string;
	type: string;
	config: FormFieldConfig;
};

export const getFormFieldDisplayValue = (field: FormField, formMetadataValue: string | undefined) => {
	// Handle checkbox fields
	if (field.type === 'checkbox') {
		return `${formMetadataValue}`?.toLowerCase() === 'true' ? i18n.t('Checked') : i18n.t('Unchecked');
	}

	// Handle signature fields
	if (field.type === 'signature') {
		return formMetadataValue ? (
			formMetadataValue.startsWith('data:') ? (
				<img src={formMetadataValue} alt={i18n.t('Signed')} style={{ maxHeight: '32px' }} />
			) : (
				i18n.t('Signed')
			)
		) : (
			i18n.t('Not Signed')
		);
	}

	// Handle file upload fields
	if (field.type === 'file') {
		return formMetadataValue ? i18n.t('Attached') : i18n.t('No attachment');
	}

	// Handle fields with options (checklist, buttonlist, dropdown, radiogroup)
	if (field.config.options && Array.isArray(field.config.options)) {
		const values = formMetadataValue?.split(',') ?? [];
		// Look up the `label` based on options of each value
		const labels = values.map((value) => {
			const option = field.config.options?.find(
				(opt: { id: string; label: string; value: string; isChecked: boolean }) => opt.value === value,
			);
			return option?.label ?? value;
		});
		return labels.join(', ');
	}

	// Return the raw value for all other field types
	return formMetadataValue ?? '';
};
